export default "__VITE_ASSET__C_ar3I$c__"